import styled from '@emotion/styled'
import * as React from 'react'

import { RadioInput } from '../../atoms'

type RadioWithLabelProps = {
  checked?: boolean
  children: React.ReactNode
  'data-testid'?: string
  onChange?: (value: boolean) => void
}

const StyledLabel = styled.label`
  vertical-align: center;
  display: table-cell;
  cursor: pointer;
`

const StyledRadioInput = styled(RadioInput)`
  margin-right: 8px;
  margin-top: -2px;
  vertical-align: middle;
`

export const RadioWithLabel = ({ checked, children, onChange, ...props }: RadioWithLabelProps) => (
  <StyledLabel>
    <StyledRadioInput
      checked={checked}
      data-testid={props['data-testid']}
      onChange={e => onChange && onChange(e.target.checked)}
    />
    {children}
  </StyledLabel>
)
